import dayjs from 'dayjs'

import { ACTIVITY_STATUS_CODES } from '../Contracts/ActivityStatus'

import type { ActivityRecord } from '../Contracts/Activity.types'

/**
 * Предикат П (`SPEC-011` §5.1, Q11.3): справа «Нова», не видалена, а
 * крайній термін уже настав (`deadline ≤ now`).
 *
 * Той самий предикат, що на беку (`ActivityRepository::applyOverdue`,
 * `ActivityEntity::getIsOverdue()`): червоний рядок, тег «Прострочена» й колір
 * події календаря мусять казати те саме, що бейдж меню. Тому — не прапорець
 * воркера, а годинник: рядок червоніє рівно тоді, коли термін минув.
 *
 * Межа включна: справа з терміном «зараз» уже прострочена (легасі тут
 * розходився — слухач рахував `<`, cron `≤`).
 */
export const isActivityOverdue = (
    record: Pick<ActivityRecord, 'status' | 'deadline' | 'isRemoved'> | null | undefined,
    now: dayjs.ConfigType = undefined
): boolean => {
    if (!record || record.isRemoved === true) return false
    if (record.status?.code !== ACTIVITY_STATUS_CODES.new) return false

    const deadline = record.deadline

    if (typeof deadline !== 'string' || deadline === '') return false

    const due = dayjs(deadline)

    if (!due.isValid()) return false

    return !due.isAfter(dayjs(now))
}

/** Справа завершена — за кодом, а не назвою: назву адміністратор може змінити. */
export const isActivityCompleted = (record: Pick<ActivityRecord, 'status'> | null | undefined): boolean =>
    record?.status?.code === ACTIVITY_STATUS_CODES.completed
